import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Button, useLocalizeMessage } from 'libs.nucleus';
import { useBooleanState } from 'libs.react';
import { ImageUploadModal } from './image_upload_modal';
/**
 * Component encapsulating a dialog that allows the user to upload an image and a button that opens that dialog.
 */
export const ImageUpload = ({ onUpload, uploader, container, openModalButton: OpenModalButton = DefaultOpenModalButton, disabled, uploaderErrorMessage, }) => {
    const [isImageUploadModalOpen, openImageUploadModal, closeImageUploadModal] = useBooleanState(false);
    const [canceled, setCanceled] = useState(false);
    const onOpen = useCallback(() => {
        setCanceled(false);
        openImageUploadModal();
    }, []);
    const onClose = useCallback((canceled) => {
        setCanceled(!!canceled);
        closeImageUploadModal();
    }, []);
    const Container = container || 'div';
    return (_jsxs(Container, { children: [_jsx(OpenModalButton, { onClick: onOpen }), _jsx(ImageUploadModal, { isOpen: isImageUploadModalOpen, onClose: onClose, onUpload: onUpload, uploader: uploader, canceled: canceled, disabled: disabled, 
                // Only show error message if the modal is open, otherwise it will be shown briefly as the modal is closing.
                uploaderErrorMessage: isImageUploadModalOpen ? uploaderErrorMessage : undefined })] }));
};
const DefaultOpenModalButton = ({ onClick }) => {
    const t = useLocalizeMessage();
    return _jsx(Button, { label: t('Upload image'), type: 'button', onClick: onClick });
};
